<ng-container *ngIf="!loadingForm; else loading">
  <sn-camera-form
    [form]="form"
    [camera]="camera"
    [isLoading]="isLoading"
    (cancel)="closeDialog()"
    (send)="onFormSent($event)"
  >
  </sn-camera-form>
</ng-container>

<ng-template #loading>
  <div class="fs__camera-drawer-loading-container">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
</ng-template>
